// The refusal a non-keeper meets on Exec, as the server words it: the keeper's first name when the store gives one.
export function execRefusal(keeperFirstName: string | null | undefined): string {
  return `Only ${keeperFirstName?.trim() || 'the keeper'} can add someone to Exec.`;
}
